import { render, staticRenderFns } from "./MyProjectsPagination.vue?vue&type=template&id=566dd81a&scoped=true&"
import script from "./MyProjectsPagination.vue?vue&type=script&lang=js&"
export * from "./MyProjectsPagination.vue?vue&type=script&lang=js&"
import style0 from "./MyProjectsPagination.vue?vue&type=style&index=0&id=566dd81a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566dd81a",
  null
  
)

export default component.exports